import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default class extends Controller {
  static targets = ["addSt"];

  connect() {
    if (document.querySelector(".existing-st")) {
      document.querySelector("#mode_operatoire_has_sous_traitant").click();
    } else {
      this.addStTarget.click();
    }
  }
}
